// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"07839070","507":"42bb2071","520":"e366b23e","874":"3388e2c7","902":"bc4e1399"}[chunkId] + ".chunk.js";
};